import {DI_TOKENS} from '@/di/di.tokens';
import {StatisticsTabsType} from '@/stores/GameStatisticsStore/GameStatisticsStore.constants';

import {injected} from 'brandi';

import {HttpError} from '@specials/project-user';

import {LoggerService} from '@/services/LoggerService/LoggerService';
import {IProjectApi} from '@/services/ProjectApi/types';
import {GameStatisticsStore} from '@/stores/GameStatisticsStore/GameStatisticsStore';

export class GameStatisticsService {
  constructor(
    private readonly gameStatisticsStore: GameStatisticsStore,
    private readonly projectApi: IProjectApi,
    private readonly loggerService: LoggerService,
  ) {}

  public async fetchStatistics(): Promise<void> {
    try {
      this.gameStatisticsStore.setLoadingFetchStatus();
      const response = await this.projectApi.fetchStatistics();
      this.gameStatisticsStore.setPersonal(response.payload);

      this.gameStatisticsStore.setSuccessFetchStatus();
    } catch (error) {
      this.loggerService.logHttpError(error as HttpError);
      this.gameStatisticsStore.setErrorFetchData(error);
      this.gameStatisticsStore.setErrorFetchStatus();
    }
  }

  public setActiveTabPersonal = (): void => {
    this.gameStatisticsStore.setActiveTab(StatisticsTabsType.Personal);
  };

  public setActiveTabProject = (): void => {
    this.gameStatisticsStore.setActiveTab(StatisticsTabsType.Project);
  };
}

injected(GameStatisticsService, DI_TOKENS.gameStatisticsStore, DI_TOKENS.projectApi, DI_TOKENS.loggerService);
